import "./AddMembersDrawer.css";
import { useRef, useState } from "react";
import Button from "../../../components/base/Button";
import Icon from "../../../components/base/Icon";
import { Drawer, DrawerRef } from "../../../components/drawers/Drawer";


export interface PickItem {
    id: string
    title?: string
    subtitle?: string
}

interface IProps {
    drawerId: string
    drawerTitle: string
    addLabel: string
    memberLabel: string
    icon?: any
    items: PickItem[]
    selectedIds: string[]
    onAddMany: (ids: string[]) => void
    onClose: () => void
}

export default function AddMembersDrawer(props: IProps) {

    const drawerRef = useRef<DrawerRef>(null);
    const [search, searchSet] = useState<string>("");
    const [checked, checkedSet] = useState<string[]>([]);

    const icon = props.icon ?? "user";
    const members = new Set(props.selectedIds);

    const match = (i: PickItem, q: string) => {
        if (window.isNullOrEmpty(q)) return true;
        const s = q.toLowerCase();
        return (i.title ?? "").toLowerCase().indexOf(s) > -1
            || (i.subtitle ?? "").toLowerCase().indexOf(s) > -1;
    }
    const list = props.items.filter(i => match(i, search));

    const toggle = (id: string) => {
        if (members.has(id)) return;
        checkedSet(c => c.indexOf(id) > -1 ? c.filter(x => x != id) : [...c, id]);
    }

    const save = () => {
        if (checked.length > 0) props.onAddMany(checked);
        drawerRef.current?.close();
    }

    return (
        <Drawer ref={drawerRef}
            id={props.drawerId}
            title={props.drawerTitle}
            titleIcon={icon}
            size="medium"
            noPadding
            onClose={props.onClose}>

            <div className="amd">
                <div className="amd-search">
                    <div className="amd-search-box">
                        <span className="amd-search-icon"><Icon icon="magnifying-glass" size={13} /></span>
                        <input type="text" className="form-control form-control-sm"
                            placeholder="Search..."
                            value={search}
                            onChange={e => searchSet(e.target.value)} />
                    </div>
                </div>

                <div className="amd-list">
                    {
                        list.length == 0 ?
                            <div className="amd-empty">{props.items.length == 0 ? "Nothing to add" : "No matches"}</div>
                            :
                            list.map((i, k) => {
                                const isMember = members.has(i.id);
                                const isChecked = isMember || checked.indexOf(i.id) > -1;
                                return (
                                    <div key={k}
                                        className={"amd-item" + (isMember ? " member" : (isChecked ? " checked" : ""))}
                                        onClick={() => toggle(i.id)}>
                                        <label className="form-check form-check-custom form-check-solid">
                                            <input className="form-check-input" type="checkbox"
                                                checked={isChecked} disabled={isMember} readOnly />
                                        </label>
                                        <span className="amd-icon">
                                            <Icon icon={icon} type="solid" />
                                        </span>
                                        <div className="amd-body">
                                            <div className="amd-title">{i.title}</div>
                                            {i.subtitle && <div className="amd-sub">{i.subtitle}</div>}
                                        </div>
                                        {
                                            isMember &&
                                            <span className="badge badge-light-primary">{props.memberLabel}</span>
                                        }
                                    </div>
                                );
                            })
                    }
                </div>

                <div className="amd-footer">
                    <Button className="w-100" icon="plus"
                        text={checked.length > 0 ? `Add ${checked.length}` : props.addLabel}
                        disabled={checked.length == 0}
                        onClick={save} />
                </div>
            </div>

        </Drawer>
    )
}
